import { observer } from 'mobx-react';
import { FC, useCallback, useMemo } from 'react';
import CustomersProfilesExport from '../../components/CustomersProfilesExport/CustomersProfilesExport';
import { customersProfilesStore } from '../../store';
import { STATUS_FILTER } from 'src/constants/main';
import { localeStore } from 'src/mobx/localesStore';
import { TBooleanInNumber } from 'src/types/main';
import Picker from 'src/view/components/Controls/Pickers/Picker/Picker';
import { IPickerOption } from 'src/view/components/Controls/Pickers/Picker/types';
import { SearchInput } from '~/view/components/Controls/Inputs';
import './style.scss';

const CustomersProfilesHeader: FC = observer((): JSX.Element => {
  const onSearch = useCallback((search: string | undefined) => {
    customersProfilesStore.setFilters({ search });
  }, []);

  const onSelectStatus = useCallback((options: IPickerOption[]) => {
    customersProfilesStore.setFilters({ status: options.length ? (options[0].value as TBooleanInNumber) : undefined });
  }, []);

  const statusPickerOptions = useMemo((): IPickerOption[] => {
    return [
      { label: localeStore.t(STATUS_FILTER.ACTIVE), value: 1 },
      { label: localeStore.t(STATUS_FILTER.INACTIVE), value: 0 },
    ];
  }, []);

  const currentSelectedStatus = useMemo((): IPickerOption[] => {
    if (customersProfilesStore.filters.status) {
      return [statusPickerOptions[0]];
    }

    if (customersProfilesStore.filters.status === 0) {
      return [statusPickerOptions[1]];
    }

    return [];
  }, [statusPickerOptions, customersProfilesStore.filters.status]);

  return (
    <div className="d-flex flex-row justify-content-between pr-4">
      <div className="d-flex flex-row gap-10">
        <SearchInput
          value={customersProfilesStore.filters.search}
          onChangeValue={onSearch}
          loading={customersProfilesStore.pagination.loading}
          contentClassName="customers-profiles-header__search"
        />

        <Picker
          options={statusPickerOptions}
          selectedOptions={currentSelectedStatus}
          onSelect={onSelectStatus}
          placeholder={localeStore.t('txt_delivery_status_h')}
        />
      </div>

      <CustomersProfilesExport />
    </div>
  );
});

export default CustomersProfilesHeader;
